import React from 'react';
import Form from '../../components/Form';
import Binder from '../../lib/Binder';
import Controller from '../../mixins/Controller';
import Dialog from '../../components/Dialog';
import Button from '../../components/Button';
import Searchers  from'../utility/Searchers';

class PSMDetailsDialog extends React.Component {
  constructor(props, context) {
    super(props, context);

    Object.assign(this, Controller);
  }

  componentDidMount = () => {
    this.initializeMixin();
  }

  handleClose = (result) => result.Cancel ? true : this.props.controller.save();

  handleClear = () => this.props.controller.clear();

  render() {
    var binder = new Binder(this);
    var controller = this.props.controller;
    var errors = controller.state.errors;
    const psmLink = controller.state.psmLink;
    const enableSave = controller.state.psmNumber !== null && controller.state.psmNumber?.length > 0 && psmLink !== null && psmLink?.length > 0;
    const displayClearButton = controller.state.displayClearButton;
    const clearButton = displayClearButton ? <div className='close-btn'><Button icon='' variant='secondary' size='sm' id='btn-save' className='' onClick={this.handleClear} disabled={false}> Clear</Button></div> : null;
    var psmLinkField = displayClearButton
      ? <Form.StaticData label='PSM Link' value={psmLink} />
      : <Form.Input bind={binder.bind('psmLink')} label='PSM Link' error={errors.psmLink} />
    var serviceLevelField=<div><Form.AutoComplete label='Service Level' id='service-level' allowClear={true} className='' bind={binder.bind('serviceLevelId')}  search={Searchers.searchServiceLevelsForCustomer(controller.state.customerId)} /></div>
    return (
      <Dialog {...this.props} header={this.props.header} width={650} height={430} id='psm-details-dlg' onClose={this.handleClose}  className='psm_dialog'>
        <Dialog.Body>
          <div className='col-md-12'>
            <Form.Input bind={binder.bind('psmNumber')} label='PSM Number' error={errors.psmNumber} />
            <div>
              {psmLinkField}
              {clearButton}
              {serviceLevelField}
            </div>
          </div>
        </Dialog.Body>
        <Dialog.Buttons>
          <Dialog.Button variant='primary' size='sm' className='btn' icon='' saving={!enableSave} result={{ Save: true }}>Save</Dialog.Button>
          <Dialog.Button variant='danger' size='sm' className='btn' icon='fa-times' result={{ Cancel: true }}>Close</Dialog.Button>
        </Dialog.Buttons>
      </Dialog>
    );
  }
}

export default PSMDetailsDialog;